import { Component, Input, forwardRef, Output, EventEmitter, AfterViewInit, SimpleChanges } from '@angular/core';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToggleButtonComponent),
        multi: true
      }
    ]
})

export class ToggleButtonComponent extends BaseControlValueAccessor<boolean> {

  @Input() type: string; // light or regular
  @Input() formControl: FormControl;
  @Input() isDisabled: Boolean = false;
  @Input() marshallNeeded = false;
  @Output() changeCallback = new EventEmitter();

  ngOnInit(): void {
    this.formControl.valueChanges.pipe(distinctUntilChanged()).subscribe((value: boolean) => {
      this.value = value;
    });
  }

  toggle(event): void {
    this.value = !this.value;
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if(this.marshallNeeded){
  //     this.value=true
  //     this.onChange(this.value);
  //     this.changeCallback.emit(this.value);
  //   }
  //   else
  //   {
  //     this.value=false;
  //     this.onChange(this.value);
  //     this.changeCallback.emit(false);
  //   }
  // }
}
